<template>
	<div class='knd-legenda'>
		<div class='inner-legenda'>
				<h5 class='knd-legenda__title'>Legenda</h5>

				<ul class='knd-legenda__list'>
					<li>
							<div class='legenda-icon legenda--school'></div>
							<div class='legende-label'>School</div>
					</li>

					<li>
							<div class='legenda-icon legenda--supermarkt'></div>
							<div class='legende-label'>Supermarkt</div>
					</li>

					<li>
							<div class='legenda-icon legenda--fastfood'></div>
							<div class='legende-label'>Fastfood</div>
					</li>

					<li>
							<div class='legenda-icon legenda--divers'></div>
							<div class='legende-label'>Divers Ongezond</div>
					</li>

				</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Legenda'
}

</script>
